<template>
  <v-container fluid>
      <v-card>
        <v-toolbar dense flat >
          <v-btn v-show="mode === 'page'" @click="back()" icon light>
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
          <v-card-text>
            <component :is="createProfileContent()">
            </component>  
          </v-card-text>
          <v-card-actions>
            <v-btn @click="editProfile()">Изменить</v-btn>
          </v-card-actions>
      </v-card>
      <v-flex xs12 md12 pa-2>
        <v-card flat ref="scroll_target">
          <v-toolbar dense flat >
            <v-toolbar-title>Документы
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-ops-btn :cxt="cxtDoc"></v-ops-btn>
          </v-toolbar>
          <v-container pt-2 px-2
            fluid
            grid-list-lg
            style="min-height: 0; margin-top: "
          >
            <v-layout row wrap >

              <template v-for="item in documents">
                <v-flex xs12 sm6>
                <v-card>
                  <v-card-title>
                    <span class="subheading"><component :is="createDocTitle(item)"></component></span>
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-card-text>
                    <component :is="createDocContent(item)">
                    </component>  
                  </v-card-text>
                  <v-card-actions>
                    <v-btn @click="openDoc(item)">Изменить</v-btn>
                  </v-card-actions>
                </v-card>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex xs12 md12 pa-2>
        <v-card flat ref="scroll_target">
          <v-toolbar dense flat >
            <v-toolbar-title>Контакты
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="openContact(null)">
              <v-icon>add</v-icon>
            </v-btn>            
          </v-toolbar>
          <v-container pt-2 px-2
            fluid
            grid-list-lg
            style="min-height: 0; margin-top: "
          >
            <v-layout row wrap >

              <template v-for="item in contacts">
                <v-flex xs12 sm6>
                <v-card>
                  <v-card-title>
                    <span class="subheading"><component :is="createContactTitle(item)"></component></span>
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-card-text>
                    <component :is="createContactContent(item)">
                    </component>  
                  </v-card-text>
                  <v-card-actions>
                    <v-btn @click="openContact(item)">Изменить</v-btn>
                  </v-card-actions>
                </v-card>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  // import server from '../../api/server'
  import formats from '../../api/formats'
  import classes from '../../api/classes'
  import vOpsBtn from '../common/OpsBtn'
  import vPanelTitle from '../info/PanelTitle'
  import people from './index.js'

  export default {
    name: 'person-page',
    components: {vPanelTitle, vOpsBtn},
    data: () => ({
      title: '',
      strategy: null,
      profile: null,
      cxtDoc: null
    }),
    props: {
      // itemId: {
      //   type: String,
      //   default: null
      // },
      fullscreen: {
        type: Boolean,
        default: false
      },
      mode: {
        type: String,
        default: 'page'
      }
    },
    created () {
      this.strategy = people.createStrategy(this, 'INDIVIDUAL')
      let cxt = new classes.MultiSelectContext(() => {})
      cxt.actionIcon = 'add'
      // cxt.mode = classes.modes.SELECT
      cxt.actions.push(new classes.Action(this, 'Паспорт РФ', null,
        () => this.openDoc(null, 'PASSPORT_RF')))
      cxt.actions.push(new classes.Action(this, 'Свидетельство о рождении РФ', null,
        () => this.openDoc(null, 'BIRTH_CERT_RF')))
      cxt.actions.push(new classes.Action(this, 'Временное удоостоверение личности РФ',
        null,
        () => this.openDoc(null, 'TEMPORARY_ID_RF')))
      cxt.actions.push(new classes.Action(this, 'Свидет о пенс. страховании РФ',
        null,
        () => this.openDoc(null, 'PENSION_CERT_RF')))
      cxt.actions.push(new classes.Action(this, 'Водительское удостоверение',
        null,
        () => this.openDoc(null, 'DRIVER_LIC_RF')))
      cxt.actions.push(new classes.Action(this, 'Свидетельство о заключении брака',
        null,
        () => this.openDoc(null, 'MARRIAGE_CERT_RF')))
      this.cxtDoc = cxt
    },
    mounted () {
      if (this.itemId) {
        this.fetchIndividual(this.itemId)
      }
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        if (newVal) {
          this.fetchIndividual(newVal)
        } else {

        }
      }
    },
    computed: {
      ...mapGetters({
      }),
      itemId () {
        return this.$route.params.personId
      },
      genders () {
        return people.genders()
      },
      citizenships () {
        return people.citizenships()
      },
      contacts () {
        let items = this.profile ? this.profile.contacts : []
        return people.sortIndividualContact(items)
      },
      documents () {
        let items = this.profile ? this.profile.docs : []
        return people.sortIndividualDoc(items)
      }
    },
    methods: {
      back () {
        this.$router.go(-1)
      },
      fetchIndividual (id) {
        if (id) {
          return this.strategy.fetchData(id).then(data => {
            this.profile = data
            this.title = this.strategy.viewTitle(this.strategy.createModelFromData(this.profile))
          })
        } else {
          this.back()
        }
      },
      editProfile () {
        people.openForm(this.itemId).then((id) => {
          this.fetchIndividual(id)
        })
      },
      createProfileContent () {
        if (this.strategy && this.strategy.viewContentComp) {
          return this.strategy.viewContentComp(this.strategy.createModelFromData(this.profile))
        }
        return this.createComp('<span></span>')
      },
      openContact (item) {
        // console.log('openContact', this.fullscreen)
        people.openContact(item ? item.id : null, this.itemId).then(() => {
          this.fetchIndividual(this.itemId)
        })
      },
      createContactTitle (item) {
        let strategy = people.createStrategy(this, 'CONTACT')
        if (strategy && strategy.viewTitleComp) {
          return strategy.viewTitleComp(strategy.createModelFromData(item))
        }
        return this.createComp('<span>Новый тип документа</span>')
      },
      createContactContent (item) {
        let strategy = people.createStrategy(this, 'CONTACT')
        if (strategy && strategy.viewContentComp) {
          return strategy.viewContentComp(strategy.createModelFromData(item))
        }
        return this.createComp('<span></span>')
      },
      openDoc (item, type) {
        people.openDoc(item ? item.id : null, this.itemId, item ? item.type : type).then(() => {
          this.fetchIndividual(this.itemId)
        })
      },
      createDocTitle (item) {
        let strategy = people.createStrategy(this, item.type)
        if (strategy && strategy.viewTitleComp) {
          return strategy.viewTitleComp(strategy.createModelFromJSON(item.model))
        }
        return this.createComp('<span>Новый тип документа</span>')
      },
      createDocContent (item) {
        let strategy = people.createStrategy(this, item.type)
        if (strategy && strategy.viewContentComp) {
          return strategy.viewContentComp(strategy.createModelFromJSON(item.model))
        }
        return this.createComp('<span></span>')
      },
      createComp (template) {
        return formats.createComp(template)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// PersonPage.vue?86965774